import { Heading, IconButton, Text, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

interface HeaderProps {
  handleGoBack: () => void;
}

export const Header: React.FC<HeaderProps> = ({ handleGoBack }) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });

  return (
    <HStack pt={Spacing['inset.lg']} alignItems="center" space={Spacing['inline.xxxs']}>
      <IconButton
        icon="ArrowLeft"
        testId="return-button"
        {...(!isMobile && { shadow: 3, variant: 'link' })}
        {...(isMobile && { p: 0, backgroundColor: 'transparent' })}
        onPress={handleGoBack}
        iconColor={Color[isMobile ? 'brand.primary.principal' : 'brand.tertiary.principal']}
        iconSize={isMobile ? 'xxs' : 'xs'}
      />
      {!isMobile && (
        <Heading testId="qa" size="h2">
          Boleta enviada
        </Heading>
      )}
      {isMobile && (
        <Text variant="bold" fontSize={Typography['fontsize.lg']} color="neutral.black">
          Boleta enviada
        </Text>
      )}
    </HStack>
  );
};
